import { CollapsibleSection as CollapsibleSectionBase } from './CollapsibleSection';
import { CollapsibleSectionHeader } from './CollapsibleSectionHeader';
import { CollapsibleSectionIcon } from './CollapsibleSectionIcon';
import { CollapsibleSectionLabel } from './CollapsibleSectionLabel';
import { CollapsibleSectionPanel } from './CollapsibleSectionPanel';
import { CollapsibleSectionContext } from './Context';

const CollapsibleSection = CollapsibleSectionBase as typeof CollapsibleSectionBase & {
  Header: typeof CollapsibleSectionHeader;
  Panel: typeof CollapsibleSectionPanel;
  Icon: typeof CollapsibleSectionIcon;
  Label: typeof CollapsibleSectionLabel;
};
CollapsibleSection.Header = CollapsibleSectionHeader;
CollapsibleSection.Panel = CollapsibleSectionPanel;
CollapsibleSection.Icon = CollapsibleSectionIcon;
CollapsibleSection.Label = CollapsibleSectionLabel;
export {
  CollapsibleSection,
  CollapsibleSectionContext,
  CollapsibleSectionBase as CollapsibleSectionWithoutStatics,
};
